export const TABLET_MAX_WIDTH = 1024;
